export enum JobHiringType {
  HIRE = 'Hire',
  OFFER = 'Offer',
}
